import { render, staticRenderFns } from "./GStoryGalleryForm.vue?vue&type=template&id=abf41540&scoped=true&"
import script from "./GStoryGalleryForm.vue?vue&type=script&lang=ts&"
export * from "./GStoryGalleryForm.vue?vue&type=script&lang=ts&"
import style0 from "./GStoryGalleryForm.vue?vue&type=style&index=0&id=abf41540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf41540",
  null
  
)

export default component.exports